import classNames from 'classnames';
import styles from './styles/styles.module.scss';

type MiddleDotProps = {
  className?: string;
};

export default function MiddleDot({ className }: MiddleDotProps) {
  return <span className={classNames(styles.dot, className)}>·</span>;
}
